/**
 * Copyright © 2026 Adnuntius AS.
 */
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {TabsModule} from 'ngx-bootstrap/tabs';

import {APP_SHARED} from '../../common/app-shared';
import {ADMIN_LIST} from '../../common/directives/admin-list';
import {CodemirrorFieldComponent} from '../../common/directives/codemirror-field.component';
import {FORM_CONTROLS} from '../../common/directives/form-controls/form-controls';
import {AdminRichTextFieldComponent} from '../../common/directives/notes/admin-rich-text-field.component';
import {NotesComponent} from '../../common/directives/notes/notes.component';
import {ObjectNotesButtonComponent} from '../../common/directives/notes/object-notes-button.component';
import {ContainerStateTitleComponent, EmptyRouteViewComponent, StaticRouteTitleComponent} from '../../common/directives/html/route-view-components';
import {StateTitleComponent} from '../../common/directives/html/state-title.component';
import {RouteTwoPanelBottomLayoutComponent, RouteTwoPanelLayoutComponent} from '../../common/directives/route-two-panel-layout.component';
import {CREATIVE_ASSETS} from '../../creative/creative-assets';
import {DefaultItemTitleComponent} from '../default-item-title.component';
import {DefaultItemTitleRouteComponent} from '../default-item-title-route.component';

export const SIMPLE_PAGE_IMPORTS = [
  ...APP_SHARED,
  FormsModule,
  TranslateModule,
  UIRouterModule,
  ButtonsModule,
  TabsModule,
  ...ADMIN_LIST,
  CodemirrorFieldComponent,
  ...CREATIVE_ASSETS,
  ...FORM_CONTROLS,
  AdminRichTextFieldComponent,
  NotesComponent,
  ObjectNotesButtonComponent,
  ContainerStateTitleComponent,
  DefaultItemTitleComponent,
  DefaultItemTitleRouteComponent,
  EmptyRouteViewComponent,
  RouteTwoPanelBottomLayoutComponent,
  RouteTwoPanelLayoutComponent,
  StateTitleComponent,
  StaticRouteTitleComponent
];
